import { getStatusColor } from '../../utils';
import { WorkplaceRequestElement } from '@gettactic/api';
import { RequestStatus } from '../../workplace-requests-settings/types';
import { StatusIcon } from '../StatusIcon';
import { StatusSelectWithModal } from '../StatusSelectWithModal';
import { capitalize } from '@gettactic/helpers';

interface StatusDisplayProps {
  request: WorkplaceRequestElement;
  isAdmin: boolean;
  isMobile: boolean;
  onStatusChange: (
    requestId: string,
    newStatus: RequestStatus,
    comment?: string
  ) => void;
}

export const StatusDisplay = ({
  request,
  isAdmin,
  isMobile,
  onStatusChange
}: StatusDisplayProps) => {
  if (isAdmin && !isMobile) {
    return (
      <StatusSelectWithModal
        request={request}
        onStatusChange={onStatusChange}
      />
    );
  }

      return (
    <div className="flex items-center space-x-1">
      <StatusIcon status={capitalize(request.status)} />
      <span
        className={`font-inter font-medium text-xs ${getStatusColor(capitalize(request.status))}`}
      >
        {capitalize(request.status)}
      </span>
    </div>
  );
};
